import { useContext } from "react";
import { ConfirmDialogTS, SnackbarDialogTS } from "../_AAA/components/ReactDialogTS";
import { MainPageDialogContext } from "../js/MainPageDialogContext";

const MainPageDialog = () => {
    const { mainPageDialogInfo, mainPageDialogClose, mainPageModal, mainPageModalClose } = useContext(MainPageDialogContext);
    return (
        <>
            <SnackbarDialogTS
                dialogInfo={mainPageDialogInfo}
                openDialog={!!mainPageDialogInfo}
                maxWidth="xs"
                closeClick={mainPageDialogClose}
                color="primary"
            />
            <ConfirmDialogTS
                modal={mainPageModal}
                modalOpen={!!mainPageModal}
                closeClick={mainPageModalClose}
            />
        </>
    );
}

export default MainPageDialog;